import { Type } from 'class-transformer';

/**
 * Model for automatic week duplication configuration
 * Stores which loved ones should have their weeks automatically duplicated
 * and on which day of the week the duplication should be triggered
 */
export class AutoDuplicateConfigModel {
  _id: string;

  /**
   * Care seeker ID
   */
  csId: string;

  /**
   * Loved one (patient) ID
   */
  loId: string;

  /**
   * Care book ID (derived from csId + loId, stored for convenience)
   */
  careBookId: string;

  /**
   * Day of week when duplication should be triggered
   * 0 = Sunday, 1 = Monday, 2 = Tuesday, 3 = Wednesday, 4 = Thursday, 5 = Friday, 6 = Saturday
   */
  dayOfWeek: number;

  /**
   * Whether this configuration is enabled
   * Allows disabling without deleting the configuration
   */
  enabled = true;

  /**
   * Number of weeks to shift forward (default: 1 = next week)
   */
  weeksOffset = 1;

  /**
   * Creation timestamp
   */
  @Type(() => Date)
  createdAt: Date;

  /**
   * Last update timestamp
   */
  @Type(() => Date)
  updatedAt: Date;
}

